export const UserProfileHeaderInfoItemName = {
  ArchivedAt: 'archivedAt',
  InvitedAt: 'invitedAt',
  RegisteredAt: 'registeredAt',
}
